module.exports = __webpack_public_path__ + "static/media/my_location.440ea8fe.svg";